import { JobLocality } from 'jobs/types';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { HttpClient } from 'shared/libs/http';
import { AsyncState } from 'shared/libs/state';
import { ApiResponseDto } from 'shared/types';

export class SearchCityStore {
   private citiesState = new AsyncState<ApiResponseDto<JobLocality[]>>();

   public selected: JobLocality | null = null;
   public cities: JobLocality[] = [];
   constructor() {
      makeObservable(this, {
         selected: observable,
         cities: observable,
         citiesLoading: computed,
         setSelected: action.bound,
      });
   }

   setSelected(c: JobLocality): void {
      this.selected = c;
   }

   get citiesLoading(): boolean {
      return this.citiesState.status === 'pending';
   }

   getCities = async ({ query }: { query: string }): Promise<void> => {
      if (query.length > 1) {
         await this.citiesState.run(
            () => {
               return HttpClient.post('/locality/search', {
                  query: query,
                  country_id: 5,
               });
            },
            {
               onSuccess: (res) => {
                  if (res.status === 200) {
                     runInAction(() => {
                        this.cities = res.response;
                     });
                  }
               },
               onError: (e) => {
                  if (e?.status === 404) {
                     runInAction(() => {
                        this.cities = [];
                        this.selected = null;
                     });
                  }
               },
            }
         );
      }
   };
}
